import { put } from 'redux-saga/effects'
import { IPcr } from '../../pcr/store/pcr.types'
import { setDiagnosisState } from '../store/diagnosis.actions'

export function* getDiagnosis(pcrDoc: IPcr) {
  const { diagnosis } = pcrDoc
  if (diagnosis && Object.keys(diagnosis).length !== 0) {
    yield put(setDiagnosisState(diagnosis))
  }
}
